// extracted by mini-css-extract-plugin
module.exports = {"head":"src-hello-react-components-app-actions-panel__head--33w6y"};